import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import axios from "axios";
import PartnerInfoForm from "./PartnerInfoForm";

const EditInfoModal = props => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { partner } = props;

  const onSubmit = async payload => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      setIsSubmitting(true);

      const { data } = await axios.put(
        `api/proxy/v2/partneradmin/${partner.id}`,
        payload,
        { headers }
      );
      props.onSuccess(data);
    } catch (e) {
      console.log(e.response || e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={props.isOpen} className={props.className}>
      <ModalHeader toggle={props.close}>Edit Partner Info</ModalHeader>
      <ModalBody>
        <PartnerInfoForm
          isSubmitting={isSubmitting}
          name={partner.name}
          description={partner.description}
          onSubmit={onSubmit}
        />
      </ModalBody>
    </Modal>
  );
};

export default EditInfoModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/EditInfoModal.js